export type TCardCategory = 'articles' | 'company-updates' | 'whitepapers' | 'technical-briefs';

export type TPaddingOptions = {
  md?: string;
  sm?: string;
  xs?: string;
  xxs?: string;
};

export enum EHashtag {
  SyntheticData = 'SyntheticData',
  AITraining = 'AITraining',
  AutonomousVehicles = 'AutonomousVehicles',
  MachineLearning = 'MachineLearning',
  ComputerVision = 'ComputerVision',
  AISimulation = 'AISimulation',
  DigitalTwin = 'DigitalTwin',
  DefenseTechnology = 'DefenseTechnology',
  Robotics = 'Robotics',
  ObjectDetection = 'ObjectDetection',
  SafetyValidation = 'SafetyValidation',
  MaritimeTechnology = 'MaritimeTechnology',
}

export type TCardProps = {
  author?: string;
  authorImage?: string;
  linkedInAuthorLink?: string;
  isCompany?: boolean;
  image?: string;
  title: string;
  description: string;
  type: 'Article' | 'Company Updates' | 'White Papers' | 'Technical Brief';
  publishDate: string;
  minutesOfRead?: number;
  category: TCardCategory;
  postUrl?: string;
  needImageBg?: boolean;
  hashTags: (keyof typeof EHashtag)[];
};
